import { Controller, Payload } from "../../config/controller";
import store, { ApplicationState } from "../../../core/store";
import { bindActionCreators, Dispatch } from "redux";

import { Paciente, initialValuePacienteState, PacienteState, PacienteActions } from "./paciente.model"
import { action } from "typesafe-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import { ResultDb } from "../../services/db";
import { StatusAppState } from "../root/root.model";

export interface PacienteViewProps {
    pacienteState: PacienteState
    pacienteActions: PacienteActions
}


class PacienteController extends Controller<Paciente, PacienteState, PacienteActions> {
    constructor() {
        super(initialValuePacienteState.row.type, initialValuePacienteState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
            showModalSelectPaciente: `@${this.moduloName}/showModalSelectPaciente`,

        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
            showModalSelectPaciente: () => action(this.actionsType.showModalSelectPaciente),
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
            takeLatest(this.actionsType.showModalSelectPaciente, this.showModalSelectPacienteEffects.bind(this))
        ]
    }

    private * showModalSelectPacienteEffects(actions: Payload) {
        try {
            yield put(this.reducer.resultAfterEffects({
                ...this.state,
                showSelectModal: true
            },this.actionsType.showModalSelectPaciente))
            if(this.state.rows.length === 0) {
                yield put(this.reducer.actions.read())
            }
        } catch (error:any) {
            console.log("error showModalSelectPacienteEffects", error);
            let msg = "Ops, ocorreu uma falha em showModalSelectPacienteEffects, detalhes: ";
            let err = msg + typeof error === 'object' ? JSON.stringify(error) : error
            yield put(this.reducer.resultAfterEffects(
                { ...this.state, loading: false, msg: err, status: "error", error: true, showAlert: true },
                this.actionsType.showModalSelectPaciente
            ))

        }
    }
        


    private * pacienteReadAllEffects(actions: Payload) {

    }
}

export const pacienteController = new PacienteController()

export const mapStateToPacienteProps = (state: ApplicationState) => ({
    pacienteState: state.pacienteState,
})

export const mapDispatchToPacienteProps = (dispatch: Dispatch) => ({
    pacienteActions: bindActionCreators({ ...pacienteController.reducer.actions }, dispatch),
})

